import { Outlet } from 'react-router-dom';
import Footer from '@/components/layout/Footer';

/**
 * PublicStandaloneLayout
 * 
 * A minimal layout for public-facing pages that don't require authentication
 * or the full AppShell with navigation. Used for intake flows like readiness assessment.
 * 
 * Features:
 * - ThreadLock branded header with dark theme
 * - Main content area (Outlet) - inherits global dark background with orange dots
 * - Footer
 * - No sidebar, no navigation, no auth guards
 */
export default function PublicStandaloneLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* ThreadLock Branded Header */}
      <header className="border-b border-slate-700 bg-slate-900/50 backdrop-blur-sm">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <a href="https://threadlock.ai" className="text-2xl font-bold hover:opacity-80 transition-opacity">
                <span className="text-brand-orange">Thread</span>
                <span className="text-slate-50">Lock</span>
              </a>
            </div>
            <div className="text-sm text-slate-300">
              Already have an account?{' '}
              <a 
                href="/login" 
                className="font-medium text-brand-orange hover:text-orange-400"
              >
                Sign In
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - inherits global ThreadLock background pattern */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
